export default {"src":"/_next/static/media/doors-replacement.ac7f053b.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};